import { render } from "./chapterChallenge.vue?vue&type=template&id=5cd5eb07&scoped=true"
import script from "./chapterChallenge.vue?vue&type=script&lang=js"
export * from "./chapterChallenge.vue?vue&type=script&lang=js"

import "./chapterChallenge.vue?vue&type=style&index=0&id=5cd5eb07&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd5eb07"]])

export default __exports__